import React from "react";
import ReactPaginate from "react-paginate";
import { Container, Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import styled from "styled-components";
import Search from "./Search";
import Property from "./Property";
import Loader from "./Loader";
import { getQueryParams } from "./utils";

const PropertiesList = styled(Row)`
  span {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
`;

class Properties extends React.Component {
  constructor(props) {
    super(props);
    const params = queryString.parse(props.location.search);
    const aid = params.aid || "";
    const category_id = params.category_id || "";
    const status_id = params.status_id || "";
    const p_min = params.p_min || "";
    const p_max = params.p_max || "";
    const bed = params.bed || "";
    const bath = params.bath || "";

    this.state = {
      loading: true,
      aid: aid,
      searchValues: {
        aid,
        category_id: category_id,
        status_id: status_id,
        p_min: p_min,
        p_max: p_max,
        bed: bed,
        bath: bath
      },
      properties: [],
      propertyTypes: [],
      total: 0,
      current: 0
    };
  }
  componentDidMount() {
    this.getProperties();
    fetch(`https://property-api.juvo.io/options${getQueryParams()}`).then(
      response =>
        response
          .json()
          .then(({ status: propertyStatuses, type: propertyTypes }) =>
            this.setState({ propertyStatuses, propertyTypes })
          )
    );
  }
  getProperties(page = 1) {
    const payload = { ...this.state.searchValues, page: page };
    delete payload.aid;

    fetch(`https://property-api.juvo.io/search/${getQueryParams()}`, {
      headers: { "Content-Type": "application/json" },
      method: "post",
      body: JSON.stringify(payload)
    })
      .then(response =>
        response
          .json()
          .then(res =>
            this.setState({
              properties: res.properties ? res.properties : res,
              loading: false,
              total: res.total,
              current: res.current
            })
          )
          .catch(() => this.setState({ loading: false }))
      )
      .catch(() => this.setState({ loading: false }));
  }
  handleSearchChange = e => {
    const searchValues = { ...this.state.searchValues };
    searchValues[e.target.name] = e.target.value;
    this.setState({ searchValues });
  };
  handleSearchSubmit = e => {
    e.preventDefault();
    let payload = this.state.searchValues;
    delete payload.aid;

    fetch(`https://property-api.juvo.io/search${getQueryParams()}`, {
      headers: { "Content-Type": "application/json" },
      method: "post",
      body: JSON.stringify({ ...payload })
    }).then(response =>
      response
        .json()
        .then(properties =>
          this.setState({ properties: properties.properties })
        )
    );
  };
  handleSearchReset = () => {
    this.setState({ searchValues: {} });
    fetch(`https://property-api.juvo.io/${getQueryParams()}`).then(response =>
      response
        .json()
        .then(properties =>
          this.setState({ properties: properties.properties })
        )
    );
  };
  handlePageClick = data => {
    this.getProperties(data.selected + 1);
  };

  render() {
    return (
      <Container>
        <header>
          <Search
            searchValues={this.state.searchValues}
            handleSearchChange={this.handleSearchChange}
            handleSearchSubmit={this.handleSearchSubmit}
            handleSearchReset={this.handleSearchReset}
            propertyStatuses={this.state.propertyStatuses}
            propertyTypes={this.state.propertyTypes}
          />
        </header>
        <main>
          <PropertiesList>
            {this.state.loading && <Loader key="loading_spinner" />}
            <ReactCSSTransitionGroup
              transitionName="properties"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300}
            >
              {this.state.properties.map(property => (
                <Property
                  key={property.id}
                  property={property}
                  propertyType={this.state.propertyTypes.find(
                    type => type.id === property.type_id
                  )}
                />
              ))}
            </ReactCSSTransitionGroup>
          </PropertiesList>
        </main>
        {this.state.total > 0 && (
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={this.state.total}
            marginPagesDisplayed={4}
            pageRangeDisplayed={10}
            onPageChange={this.handlePageClick}
            containerClassName="juvoPagination"
            activeClassName="activePage"
            previousClassName="previousPage"
            nextClassName="nextPage"
            pageClassName="juvoPage"
          />
        )}
      </Container>
    );
  }
}

export default withRouter(Properties);



// WEBPACK FOOTER //
// ./src/components/Properties.js